import React from 'react';
import { ExternalLink, FileDown } from 'lucide-react';
import { useYearContext } from '../components/Layout.jsx';
import { Empty } from '../components/states.jsx';

const isExternal = (url) => /^https?:\/\//i.test(url);

export default function Materials() {
  const { year } = useYearContext();
  const materials = year.materials || [];

  return (
    <>
      <div className="page-head">
        <h1>Materiály</h1>
        <p>Knihy a skripta, ze kterých v semináři vycházíme.</p>
      </div>

      {materials.length === 0 ? (
        <Empty title="Zatím tu nic není">Materiály sem přidám během roku.</Empty>
      ) : (
        <div className="card-grid">
          {materials.map((material) => (
            <a
              key={material.id}
              href={material.url}
              className="card card-link"
              {...(isExternal(material.url)
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : {})}
            >
              <div className="section-title" style={{ marginBottom: material.description ? '.4rem' : 0 }}>
                {isExternal(material.url)
                  ? <ExternalLink size={16} aria-hidden="true" style={{ color: 'var(--accent)', flex: 'none' }} />
                  : <FileDown size={16} aria-hidden="true" style={{ color: 'var(--accent)', flex: 'none' }} />}
                <h2 style={{ fontSize: '1rem' }}>{material.title}</h2>
              </div>
              {material.description && (
                <p style={{ color: 'var(--text-muted)', fontSize: '.9rem', margin: 0 }}>{material.description}</p>
              )}
            </a>
          ))}
        </div>
      )}
    </>
  );
}
